<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.notification.history.history') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'administration.mobile_feature.notification.history.history'
            ),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-sm-12 col-md-4 col-lg-4 d-flex justify-content-end"
          ></div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-date-picker-input readonly v-model="from_date">
            </ts-date-picker-input>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-date-picker-input v-model="to_date" readonly>
            </ts-date-picker-input>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-loading-banner :loading="loadingPreData">
              <select
                class="form-control text-center"
                @change="filter"
                v-model="not_type_id"
              >
                <option value="" selected>
                  {{
                    $t(
                      'administration.mobile_feature.notification.history.select_notification_type'
                    )
                  }}
                </option>
                <option
                  v-for="(notification_type, index) in notification_types"
                  :key="index"
                  :value="notification_type.not_type_id"
                >
                  {{ notification_type.not_type }}
                </option>
              </select>
            </ts-loading-banner>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-input
              style="width:100%"
              v-model="search"
              :placeholder="
                $t('administration.mobile_feature.notification.history.search')
              "
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.notification_subject }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.notification_type }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.activated_type }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.notification_method }}
            </td>
            <td class="ts-whitespace-no-wrap" style="background: #f1f3f4">
              <div v-html="record.notification_content" />
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.sent_time }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.finish_time }}
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'notification-monitoring',
  data() {
    return {
      not_type_id: '',
      loadingPreData: false,
      loading: false
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('notificationHistory', [
      'resources',
      'pagination',
      'notification_types'
    ]),
    search: {
      get() {
        return this.$store.state.notificationHistory.search
      },
      set(newValue) {
        this.$store.commit('notificationHistory/SET_SEARCH', newValue)
        this.$store.commit('notificationHistory/RESET_CURRENT_PAGE')
      }
    },
    from_date: {
      get() {
        return this.$store.state.notificationHistory.from_date
      },
      set(val) {
        this.$store.commit('notificationHistory/SET_FROM_DATE', val)
      }
    },
    to_date: {
      get() {
        return this.$store.state.notificationHistory.to_date
      },
      set(val) {
        this.$store.commit('notificationHistory/SET_TO_DATE', val)
      }
    },
    columns() {
      return [
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.subject'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.notification_type'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.activate_type'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.notification_method'
          ),
          style: 'text-align:center'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.content'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.sent_at'
          ),
          style: 'text-align:center'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.history.finished_at'
          ),
          style: 'text-align:center'
        }
      ]
    }
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('notificationHistory/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
          this.fetchData()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('notificationHistory/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    filter() {
      this.$store.commit(
        'notificationHistory/SET_SELECTED_NOTIFICATION_TYPE',
        this.not_type_id
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    from_date: function(date) {
      this.fetchData()
    },
    to_date: function(date) {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('notificationHistory/RESET_STATE')
    }
    next()
  }
}
</script>
